// extracted by mini-css-extract-plugin
export var content = "points-title-module--content--edbd9";
export var keton = "points-title-module--keton--3f916";
export var pointsTitle = "points-title-module--points-title--04637";
export var title = "points-title-module--title--47298";